export const SALES_ORDER_HEADER_CONSTRAINTS = {
    customer: { label: 'Customer' },
    brand: { label: 'Brand' },
    locationGroup: { label: 'Warehouse' },
    paymentTerms: { label: 'Payment terms' },
    customerPurchaseOrder: { maxLength: 25, label: 'Customer PO' },
    note: { label: 'Note', max: 5_000 },
    deliveryPreferences: { label: 'Delivery preferences', max: 5_000 },
    manifestNumber: { label: 'Manifest number', maxLength: 100 },
    internalNotes: { label: 'Internal notes', max: 5_000 },
};
//# sourceMappingURL=header-constraints.js.map